var strUtil = {
  lc: require('./lc'),
  lowerCase: require('./lower-case'),
  lowerFirst: require('./lower-first'),
  substitute: require('./substitute'),
  uc: require('./uc'),
  upperCase: require('./upper-case'),
  upperFirst: require('./upper-first')
};
module.exports = strUtil;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/string/index.js
// module id = 230
// module chunks = 0